export default "__VITE_ASSET__CM8XvgJE__"